import { DOCUMENT, Inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerService {
  private gtmId = environment.googleTagManagerId;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  public loadGTM(): void {
    // Prevent duplicate loading
    if (this.document.getElementById('gtm-script') || !this.gtmId || this.gtmId === '') {
      return;
    }

    const gtmScript = this.document.createElement('script');
    gtmScript.id = 'gtm-script';
    gtmScript.async = true;
    gtmScript.text = `
      (function(w,d,s,l,i){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),
            dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${this.gtmId}');
    `;
    this.document.head.appendChild(gtmScript);

    const gtmNoscript = this.document.createElement('noscript');
    gtmNoscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${this.gtmId}"
              height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    this.document.body.insertBefore(gtmNoscript, this.document.body.firstChild);
  }
}
